import { p } from '@/utils/content-blocks';

export const UPDATE_CHECKLIST = [
	'Back up chats in Settings → Chats → Chat backup',
	'Check current version in GB Settings → About (target 18.80)',
	'Download the latest APK from the download page (~82 MB)',
	'Install over the old app without uninstalling first',
	'Open chats and send a test message to confirm sync',
];

export const UPDATE_TIMELINE = [
	{
		step: 1,
		title: 'Back up first',
		text: 'Run a local or Google Drive backup while you still have a working login. Skipping this is the main reason people lose threads during updates.',
	},
	{
		step: 2,
		title: 'Download new APK',
		text: 'Grab v18.80 from GBWaps, confirm file size, and keep the APK in Downloads until install finishes.',
	},
	{
		step: 3,
		title: 'Install over existing',
		text: 'Open the file, tap Install, and wait—Android should upgrade in place when the signature matches the previous mod.',
	},
	{
		step: 4,
		title: 'Verify & restore',
		text: 'Check About for 18.80, restore backup if prompted, and warm up the account with normal chats before heavy privacy toggles.',
	},
];

export const UPDATE_HOWTO_SCHEMA = {
	'@context': 'https://schema.org',
	'@type': 'HowTo',
	name: 'How to Update GB WhatsApp Safely',
	description: 'Update GB WhatsApp to the latest version without losing chats by backing up, downloading, and installing over the existing app.',
	step: UPDATE_TIMELINE.map((s) => ({
		'@type': 'HowToStep',
		position: s.step,
		name: s.title,
		text: s.text,
	})),
};

export const UPDATE_SECTIONS = [
	{
		id: 'update-safely',
		h2: 'How to Update GB WhatsApp Safely',
		layout: 'timeline',
		blocks: [
			p([
				{
					text: 'Updates never arrive from Play Store. The safe path is backup → download → install on top → verify. Do not uninstall unless you are switching developers or leaving mods entirely.',
				},
			]),
			p([
				{ text: 'New to sideloading? Read ' },
				{ link: { to: '/install-gbwhatsapp/', text: 'How to Install GB WhatsApp APK' } },
				{ text: ' first—update uses the same unknown-sources flow.' },
			]),
		],
	},
	{
		id: 'why-update',
		h2: 'Why You Should Update GB WhatsApp',
		blocks: [
			p([
				{
					text: 'Developers ship 18.80 builds with login fixes, anti-ban tweaks, and Android 14 patches. Running an outdated package is a common trigger for “This version is outdated” banners and temporary bans.',
				},
			]),
			p([
				{
					text: 'Updates also bring theme store fixes, anti-delete stability, and media sending improvements. Staying current is less about new stickers and more about keeping your number working on mod servers.',
				},
			]),
		],
	},
	{
		id: 'backup',
		h2: 'Backup Chats Before Updating',
		layout: 'checklist',
		blocks: [
			p([
				{
					text: 'Open GB WhatsApp → Settings → Chats → Chat backup → Back Up. Wait until it completes on Wi‑Fi; large media backups can take 10–30 minutes.',
				},
			]),
			p([
				{
					text: 'Copy the GBWhatsApp folder to PC or cloud if you plan risky experiments. Local databases live under internal storage; OEM cleaners can delete them if storage is critically low.',
				},
			]),
		],
	},
	{
		id: 'step-process',
		h2: 'Step-by-Step Update Process',
		blocks: [
			p([
				{
					text: 'Follow the timeline above in order. If install says “App not installed”, you likely have a signature mismatch—download from the same source line you used before or see install troubleshooting.',
				},
			]),
		],
	},
	{
		id: 'avoid-data-loss',
		h2: 'How to Avoid GB WhatsApp App Data Loss',
		blocks: [
			p([
				{
					text: 'Never uninstall before backup finishes. Do not jump between unrelated mod families (different signatures) without migrating backups manually.',
				},
			]),
			p([
				{
					text: 'Avoid “Clear data” during login issues until you try installing the newest APK. Clearing wipes local DB files even when cloud backup exists if restore fails.',
				},
			]),
			p([
				{
					text: 'Keep at least 300 MB free during update—APK plus cache expansion needs headroom on MIUI and ColorOS devices.',
				},
			]),
		],
	},
	{
		id: 'update-errors',
		h2: 'Common Update Errors',
		blocks: [
			p([
				{
					text: 'Login loop after update: auto-sync time, toggle airplane mode, download fresh 18.80. Duplicate backup prompts: complete one restore path only.',
				},
			]),
			p([
				{
					text: '“App not installed” on update: old signature from another mod still on phone—remove only the conflicting mod, not official WhatsApp, after backup.',
				},
			]),
			p([
				{
					text: 'Media missing after update: restore from backup; if paths changed, re-download media in chat threads once storage permission is granted on Android 13+.',
				},
			]),
		],
	},
	{
		id: 'new-features',
		h2: 'GB WhatsApp New Features in Latest Version',
		blocks: [
			p([
				{
					text: 'v18.80 builds commonly highlight stronger anti-ban heartbeat tweaks, smoother theme loading, extended message edit windows on some forks, and better status download stability.',
				},
			]),
			p([
				{
					text: 'Privacy panels add finer control for hide online, typing, and recording indicators. Check GB Settings after update—menu labels move between developers.',
				},
			]),
			p([
				{
					text: 'Compare with the full ',
				},
				{ link: { to: '/features/', text: 'GB WhatsApp Features' } },
				{ text: ' list if you want toggle-by-toggle explanations.' },
			]),
		],
	},
];
